import { ReactElement } from 'react';
import { Button, Link } from '@Hotels-at-Home/hah-fe-core/dist/components';

interface IProps {
  id: number;
  hero: {
    heading: any;
    text: any;
  };
  last?: {
    url: string;
    id: number;
    heading: any;
    text: any;
    cta: string;
  };
  children: React.ReactNode;
}

const Article = ({ id, hero, last, children }: IProps): ReactElement => (
  <div className="article-wrapper">
    <section className="article-hero" id={`article${id}`}>
      <picture>
        <source
          srcSet={`/images/blog/hp-blog-mercure-article-${id}-content.webp`}
          media="(max-width: 768px)"
        />
        <img src={`/images/blog/hp-blog-mercure-article-${id}-banner.webp`} alt={hero.heading} />
      </picture>
      <div className="article-heading-wrapper">
        <h1>{hero.heading}</h1>
        <p>{hero.text}</p>
      </div>
    </section>
    <section className="article-content">{children}</section>
    {last && (
      <Link
        href={last.url}
        noClass
        className="article-footer"
        data-event-name="bloc_interact"
        data-bloc-name={last.heading}
      >
        <section className="article-last">
          <div className="article-last-content">
            <h2>{last.heading}</h2>
            <p>{last.text}</p>
            <Button variant="main">{last.cta}</Button>
          </div>
          <picture>
            <img
              src={`/images/blog/hp-blog-mercure-article-${last.id}-content.webp`}
              alt={last.heading}
              width={1090}
              height={475}
            />
          </picture>
        </section>
      </Link>
    )}
  </div>
);

export default Article;
